export default __webpack_public_path__ + "static/media/thumbnail.e4d23b2c.png";